import { EAccountLegalType } from '../../types/newbuildingBroker/accountLegalType';
import { IApplicationState } from '../../types/redux';

// TODO: Удалить в CD-204351
interface INewbuildingBrokerCommon {
  accountLegalType: EAccountLegalType;
  hasConfirmedPhone: boolean;
  partnerRewardsRegistrationStatus: string;
}

// TODO: Убрать комментарий в CD-204351
export const getBrokerParams = (state: IApplicationState): INewbuildingBrokerCommon | null => {
  // @ts-expect-error - TS не знает о новых полях
  return state.newbuilding?.newbuildingBrokerCommon ?? null;
};
